module.exports = __webpack_public_path__ + "static/img/comfort_screen_monitor_mode.a20a3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/comfort_screen_monitor_mode.png
// module id = 45
// module chunks = 1 2